import { Schema } from "rsuite";

import { str40 } from "components/Form/Text";

const { StringType, NumberType } = Schema.Types;

export const formSmsModel = Schema.Model({
    name: str40,
    sp_key: NumberType()
        .isRequired("Required")
});

export const formDialerModel = Schema.Model({
    tprefix: StringType()
        .pattern(/^\d*[#]?\d*$/, "Techprefix can contain only numbers and one character\"#\"")
        .maxLength(10, "Technical prefix can contain a maximum of 10 characters"),
    port: NumberType()
        .isRequired("Required")
        .range(0, 65535, "Enter the correct port"),
    ip: StringType()
        .isRequired("Required")
        .pattern(
            /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
            "Please enter legal IP Address"
        ),
    prt_key: NumberType().isRequired("Required")
});

export const formExternalResourceModel = (requireRegistration) => {
    const externalLogin = StringType()
        .maxLength(64, "Login can contain a maximum of 255 characters");
    const externalPassword = StringType()
        .maxLength(64, "Password can contain a maximum of 255 characters");

    if (requireRegistration) {
        externalLogin.isRequired("Required");
        externalPassword.isRequired("Required");
    }

    return Schema.Model({
        external_fqdn: StringType()
            .maxLength(255, "FQDN can contain a maximum of 255 characters")
            .isRequired("Required"),
        external_sip_port: NumberType()
            .range(0, 65535, "Enter the correct SIP port")
            .isRequired("Required"),
        external_tprefix_out: StringType()
            .pattern(/^\d*[#]?\d*$/, "Techprefix can contain only numbers and one character\"#\"")
            .maxLength(10, "Technical prefix can contain a maximum of 10 characters"),
        external_login: externalLogin,
        external_password: externalPassword,
        external_realm: StringType()
            .maxLength(255, "Realm can contain a maximum of 255 characters")
    });
};

export const buildMoreOptionsModel = (service) => {
    return Schema.Model({
        postback_url: StringType()
            .pattern(
                /http(s)*:\/\/[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#&={}]*)?/
                , "Please enter a valid url")
            .addRule((value) => {
                const questionMarkRegex = /\?+/g;
                const filteredUrlString = String(value || "").replace(questionMarkRegex, "?");

                const correctValuesList = service
                    ? ["{{cdrid}}", "{{calling_number}}", "{{called_number}}", "{{rate}}", "{{duration}}", "{{payout}}", "{{calltime}}", "{{additional_tones}}"]
                    : ["{{smsid}}", "{{smsid2}}", "{{senderid}}", "{{smstime}}", "{{payout}}", "{{called_number}}", "{{smstext}}"];
                const paramString = filteredUrlString.split("?")[1];
                const queryString = new URLSearchParams(paramString);
                const queryStringKeyList = Array.from(queryString.keys());

                const correctKeyList = queryStringKeyList.filter(key => {
                    const fieldValue = queryString.get(key);
                    const notConstValueRegex = /{{.*?}}/;

                    const isNotConstValue = notConstValueRegex.test(fieldValue);

                    if (!isNotConstValue) {
                        return true;
                    } else if (isNotConstValue && correctValuesList.includes(fieldValue)) {
                        return true;
                    }
                    return false;
                });

                return correctKeyList.length === queryStringKeyList.length;
            }, "Please enter a valid parameters"),
        postback_method: StringType()
    });
};
